export const initLinks = function (config) {

  $('a.next').each(function(){
    $(this).addClass('icon-link icon-link-hover');
    let text = $(this).text();
    $(this).html(text + '<i class="bi bi-chevron-right"></i>')
  });
  $('a.prev').each(function(){
    $(this).addClass('icon-link icon-link-hover');
    let text = $(this).text();
    $(this).html('<i class="bi bi-chevron-left"></i>' + text)
  });
  $('a.more').each(function(){
    $(this).addClass('icon-link icon-link-hover');
    $(this).attr('style','--bs-icon-link-transform: translate3d(0, .125rem, 0);');
    let text = $(this).text();
    $(this).html(text + '<i class="bi bi-chevron-down"></i>')
  });
  $('a.download').each(function(){
    $(this).addClass('icon-link icon-link-hover');
    $(this).attr('style','--bs-icon-link-transform: translate3d(0, .125rem, 0);');
    let text = $(this).text();
    $(this).html(text + '<i class="bi bi-download"></i>')
  });


  $('section.flixx_news .item, section.flixx_events .item').each(function(){
    let
      $item = $(this),
      $link = $item.find('a')
    ;

    if ($link.length > 0){
      $item.addClass('is-link');
      $item.click(function(e){
        window.location.href = $link.attr('href');
      });
    }
  });
}
